import {
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
  useDeleteMutation,
} from "slices/api";
import { ROLE } from "tagTypes";

export const useGetRolesQuery = (
  query = {},
  isFireSafety = false,
  isUtilityTunnel = false
) =>
  useGetQuery({
    endpoint: isFireSafety
      ? "/fire-safety-role"
      : isUtilityTunnel
      ? "uta-card-issuance-role"
      : "/role",
    query,
    tags: [ROLE],
  });

export const useLazyRoleQuery = () => {
  const [getRole, data] = useLazyGetQuery();
  const role = async (query = {}) =>
    await getRole(
      {
        endpoint: "/role",
        query,
        tags: [ROLE],
      },
      true
    ).unwrap();
  return [role, data];
};

export const usePostRoleMutation = () => {
  const [role, data] = usePostMutation();
  const addRole = async (payload, query = {}) =>
    await role({
      endpoint: "/role",
      query,
      payload: payload || {},
      toastMessage: "Role added successfully",
      tags: [ROLE],
    }).unwrap();

  return [addRole, data];
};

export const usePutRoleMutation = () => {
  const [role, data] = usePutMutation();
  const updateRole = async (payload, id, query = {}) =>
    await role({
      endpoint: `/role/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Role updated successfully",
      tags: [ROLE],
    }).unwrap();
  return [updateRole, data];
};

export const useDeleteRoleMutation = () => {
  const [role, data] = useDeleteMutation();
  const deleteRole = async (id, query = {}) =>
    await role({
      endpoint: `/role/${id}`,
      query,
      toastMessage: "Role deleted successully",
      tags: [ROLE],
    }).unwrap();
  return [deleteRole, data];
};
